import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useWallet } from 'use-wallet'
import styled from 'styled-components'

import Page from 'components/Page'
import PageHeader from 'components/PageHeader'

import MyTicketTable from 'components/TicketTable'
import { AccountContext } from 'contexts/AccountProvider'
import { PoolListContext } from 'contexts/PoolListProvider'

import dice from 'assets/img/dice.png'

const MyTickets = (props) => {
  const [data, setData] = useState([])
  const { account } = useWallet()
  const { poolsContract } = useContext(AccountContext)
  const { poolList } = useContext(PoolListContext)

  const myTicket = async (lotteryPool) => {
    const myTicketEvents = await lotteryPool.getPastEvents('Purchase', {
      filter: {
        user: account.toString(),
      },
      fromBlock: 1,
      toBlock: 'latest',
    })
    const tmpPools = []
    const poolListTmp = poolList
    if (myTicketEvents) {
      myTicketEvents.forEach((ticket) => {
        const key = parseInt(ticket.returnValues.poolId)
        if (poolListTmp[key]) {
          poolListTmp[key].myTicket = ticket.returnValues.tickets
          poolListTmp[key].transactionHash = ticket.transactionHash
          tmpPools.push({ ...poolListTmp[key] })
        }
      })
      setData(tmpPools)
      return myTicketEvents
    }
  }

  useEffect(() => {
    if (account && poolList.length > 0) {
      myTicket(poolsContract)
    }
  }, [account, poolList])

  const history = useHistory()
  const handleGoHome = () => {
    history.push('/')
  }

  return (
    <Page>
      <div>
        <PageHeader
          icon={<img src={dice} height="120" alt="dice" />}
          onClick={handleGoHome}
          title="My Tickets"
        />
        <MyTicketTable data={data} />
      </div>
    </Page>
  )
}

const StyledCards = styled.div`
  width: 912px;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
  }
`
const StyledRow = styled.div`
  display: flex;
  margin-bottom: ${(props) => props.theme.spacing[4]}px;
  flex-flow: row wrap;
  @media (max-width: 768px) {
    width: 100%;
    flex-flow: column nowrap;
    align-items: center;
  }
`
export default MyTickets
